import axiosInstance from './axiosConfig';
import { ApiResponse } from './generalService';

export interface AppVersions {
  ios?: string;
  android?: string;
}

export interface AppVersionResponse {
  appVersion: AppVersions | null;
}

export const getAppVersion = () =>
  axiosInstance.get<ApiResponse<AppVersionResponse>>('/app-version');

export const updateAppVersion = (fields: AppVersions & { force?: boolean }) =>
  axiosInstance.put<ApiResponse<AppVersionResponse>>('/app-version', fields);
